import { UseQueryResult, useQuery } from 'react-query';
import { ChurnReport, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseChurn {
  month: string | null;
  enabled?: boolean;
}

function useChurn({ month, enabled = true }: IUseChurn): UseQueryResult<{ data: ChurnReport }> {
  const params: UrlParams = {};

  if (month) {
    params.month = month;
  }

  return useQuery(['churn', month], () => client.get(`reports/churn?${encodeUrlParams(params)}`), {
    enabled: !!month && enabled,
    staleTime: 86400000, // 1 day
  });
}

export default useChurn;
